import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeStyle, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'noSanitize'
})
export class NoSanitizePipe implements PipeTransform {
  constructor(
    private domSanitizer: DomSanitizer
  ) {
  }

  transform(value: string, context: SecurityContext = SecurityContext.STYLE): SafeStyle | SafeHtml | null {
    switch (context) {
      case SecurityContext.STYLE:
        return this.domSanitizer.bypassSecurityTrustStyle(value);
      case SecurityContext.HTML:
        return this.domSanitizer.bypassSecurityTrustHtml(value);
      default:
        return null;
    }
  }
}
